/**
 * Frontend logger — IS-INV-027 compliant.
 *
 * Wraps console methods with log-level filtering so debug output is suppressed
 * in production. Never log tokens, secrets, or PII.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  error: (message: string, meta?: Record<string, unknown>) => {
    // eslint-disable-next-line no-console
    console.error(`[hub-ui] ${message}`, meta ?? '');
  },
  warn: (message: string, meta?: Record<string, unknown>) => {
    // eslint-disable-next-line no-console
    console.warn(`[hub-ui] ${message}`, meta ?? '');
  },
  info: (message: string, meta?: Record<string, unknown>) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.info(`[hub-ui] ${message}`, meta ?? '');
    }
  },
  debug: (message: string, meta?: Record<string, unknown>) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.debug(`[hub-ui] ${message}`, meta ?? '');
    }
  },
};
